import React from 'react'
import { Tooltip, Button, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal
const showConfirm = (message = "Do you want to delete this data?", callback) => {
    confirm({
        title: message,
        icon: <ExclamationCircleOutlined />,
        centered: true,
        onOk() {
            callback();
        },
        onCancel() {
            console.log('Cancel');
        },
    });
}

const ActionButton = ({ title, showTitle = false, icon, onClicked = () => { }, confirmText = "", danger = false, visible = true, disabled = false }) => {

    console.log("typeof icon " + typeof icon + ((typeof icon) === "string"))
    const iconNode = ((typeof icon) === "string") ? (<img style={{ width: "auto", height: "16px" }} src={icon}></img>) : icon;

    if (!visible)
        return null

    return (
        <Tooltip title={title}>
            {
                confirmText === "" ? (<div onClick={onClicked} style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", fontSize: "13px", margin: "1px" }}>

                    <Button disabled={disabled} type="link" danger={danger} icon={iconNode} />{showTitle ? title : ""}

                </div>) : (
                    <div onClick={() => {
                        showConfirm(confirmText, onClicked)
                    }} style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", fontSize: "13px", margin: "1px" }}>

                        <Button danger={danger} type="link" icon={iconNode} />{showTitle ? title : ""}

                    </div>
                )
            }
        </Tooltip>
    )
}

export default ActionButton